<ion-header [translucent]="true">
  <ion-toolbar color="success">
    <ion-buttons slot="start">
      <ion-menu-button/>
    </ion-buttons>
    <ion-title>Sincronização</ion-title>
    <ion-buttons slot="end">
<!--      <ion-icon size="large" (click)="refresh()" name="refresh" />-->
      <ion-button (click)="sincronizar()" fill="clear">
        <ion-icon *ngIf="!working" slot="icon-only" name="play"></ion-icon>
        <ion-spinner *ngIf="working"></ion-spinner>
      </ion-button>
      <ion-icon  />
    </ion-buttons>
    <ion-progress-bar [value]="progress" type="{{type}}"></ion-progress-bar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-item *ngFor="let b of enviaveis">
      <ion-icon  slot="start" name="cloud-upload-outline"></ion-icon>
      <ion-label>{{b.nome}}</ion-label>
      <ion-icon *ngIf="b.ok == false" slot="start"  name="close-circle"></ion-icon>
      <ion-label slot="end">{{b.texto}}</ion-label>
      <ion-icon *ngIf="b.ok" slot="start"   color="success" name="checkmark"></ion-icon>
      <ion-spinner *ngIf="b.sincronizando" name="lines"></ion-spinner>

    </ion-item>
    <ion-item *ngFor="let b of baixaveis">
      <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
      <ion-label>{{b.nome}}</ion-label>
      <ion-icon *ngIf="b.ok == false" slot="start"  name="close-circle"></ion-icon>
      <ion-icon *ngIf="b.ok" slot="start" color="success" name="checkmark"></ion-icon>

      <ion-label slot="end">{{b.texto}}</ion-label>

      <ion-spinner *ngIf="b.sincronizando" name="lines"></ion-spinner>

    </ion-item>


  </ion-list>
  <span>{{texto}}</span>
</ion-content>
